import React, { FC } from 'react';

const RemovalPharmacies: FC = () => {
  return (
    <div>
      <p>
        Для видалення аптеки необхідно просто не присилати її у списку аптек і
        вона видалиться автоматично, або ще є можливість прислати параметр
        &quot;enabled&quot;: false та конкретна аптека деактивується.
      </p>
    </div>
  );
};

export default RemovalPharmacies;
